import * as React from 'react';
export const licenseFeeSvg = React.forwardRef(function licenseFeeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10 9.36v1.44H2V9.36h8Zm.56-.56V3.2a.56.56 0 0 0-.56-.56H2a.56.56 0 0 0-.56.56v5.6c0 .309.25.56.56.56v1.44a2 2 0 0 1-2-2V3.2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5.6a2 2 0 0 1-2 2V9.36a.56.56 0 0 0 .56-.56Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.34 4.92a.72.72 0 0 1 1.44 0v2.16a.72.72 0 1 1-1.44 0V4.92Z',
    }),
  );
});
licenseFeeSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var licenseFee = {
  category: 'icon',
  colorable: true,
  name: 'licenseFee',
  svg: licenseFeeSvg,
};
